const consumerFlow = [
  /*** Step 0 ***/
  ["Home"],

  /*** Step 1 ***/
  ["Addresses"],

  /*** Step 2 ***/
  ["TitolareEffettivo", "Gianos", "ScopoRapporto"],

  /*** Step 3 ***/
  ["ConfirmCard", "CardDocumentation", "RequestCertificate"],

  /*** Step 4 ***/
  ["CardSign", "InfocertSign", "ConfirmAccessCode", "ConfirmMobileToken"],

  /*** Step 5 ***/
  ["RegistrationCompleted"],

  /*** Step 6 has beend merged with step 5  ***/
  //TODO: check this
  ["RegistrationCompleted"],
  /*** Step 7 [user status: ?] ***/
  ["RegistrationCompleted"],
  /*** Step 8 [user status: ?] ***/
  ["RegistrationCompleted"],
  /*** Step 9 [user status: CONFIRMED] ***/
  ["RegistrationCompleted"]
];

export default consumerFlow;
